<template>
	<div>
		<title-bar :title-stack="titleStack"/>

		<section class="section is-main-section">
			<card-component title="基本情報" icon="">
				<b-field label="贈呈" horizontal>
					<div>{{ present }}</div>
				</b-field>

				<b-field label="獲得" horizontal>
					<div>{{ recieve }}</div>
				</b-field>

				<b-field label="コイン" horizontal>
					<b-select v-model="coinId">
						<option v-for="row in coins" :key="row.id" :value="row.id">
							{{ row.name }}
						</option>
					</b-select>
				</b-field>

				<b-field label="コメント" horizontal>
					<textarea class="textarea" v-model="comment"></textarea>
				</b-field>

				<b-field class="mt-40" horizontal>
					<div>
						<b-button @click="$router.go(-1)">戻る</b-button>
						<b-button type="is-primary" class="ml-50" :loading="isLoading" @click="onSubmitClick">更新</b-button>
					</div>
				</b-field>
			</card-component>
		</section>
	</div>
</template>

<style lang="scss" scoped>

</style>

<script>
import TitleBar from '@/components/TitleBar'
import CardComponent from '@/components/CardComponent'
import mapValues from 'lodash/mapValues'
import CheckboxPicker from '@/components/CheckboxPicker'
import RadioPicker from '@/components/RadioPicker'
import ImagePicker from '@/components/ImagePicker'
import DatePicker from '@/components/DatePicker'
import DateSelect from '@/components/DateSelect'

export default {
	name: 'PresentEdit',
	components: {
		ImagePicker,
		RadioPicker,
		CheckboxPicker,
		CardComponent,
		TitleBar,
		DatePicker,
		DateSelect,
	},
	data () {
		return {
			id: '',
			coinId: '',
			coins: [],
			comment: '',
			present: '',
			recieve: '',
			isLoading: false,
		}
	},
	computed: {
		titleStack () {
			return [
				'贈呈データ編集',
			]
		}
	},
	mounted() {
		this.init();
	},
	methods: {
		onSubmitClick: async function() {
			for (let key in this.errors) {
				this.errors[key] = '';
			}

			this.isLoading = true;
			let data = {
				"id": this.id,
				"coin_id": this.coinId,
				"comment": this.comment,
			};
			this.$utils.log(data);

			let ep = 'present-coins';
			this.$utils.log(ep);

			try {
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.$router.push({ name: 'present-list' });
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
				if (error.response.status === 400) {
					let details = error.response.data.details;
					for (let key in details) {
						this.errors[this.$utils.toCamelCase(key)] = details[key];
					}
				}
			} finally {
				this.isLoading = false;
			}
		},
		init: function() {
			this.getData();
		},
		getData: async function() {
			let loader = this.$buefy.loading.open();
			let ep = 'present-coins/screen/' + this.$route.params.presentCoinId;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.id = res.data.id;
				this.present = res.data.present;
				this.recieve = res.data.recieve;
				this.coinId = res.data.coin_id;
				this.coins = res.data.coins;
				this.comment = res.data.comment;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loader.close();
			}
		},
	}
}
</script>
